import type { SVGProps } from 'react';
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 8 5" {...props}>
    <path d="M3.64645 0.853553L0.853553 3.64645C0.538571 3.96143 0.761654 4.5 1.20711 4.5H6.79289C7.23835 4.5 7.46143 3.96143 7.14645 3.64645L4.35355 0.853553C4.15829 0.658291 3.84171 0.658291 3.64645 0.853553Z" />
  </svg>
);
export default SvgArrowUp;
